﻿<template>
    <div :class="['mb-3 form-group', {'is-invalid': validator.$error, 'is-valid': !validator.$error && validator.$dirty}]">
        <label v-if="label" :for="labelForAttributeValue" :class="['form-label', {required: showLabelAsRequired}]">{{ label }}</label>
        <slot></slot>
        <div :class="{ 'invalid-feedback': validator.$error, 'valid-feedback': !validator.$error  }" v-if="validator.$error && !hideErrorMessage">
            <div v-for="error in validator.$errors" :key="error.$message">
                {{ error.$message }}
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            validator: {
                type: Object,
                default: () => ({
                    $dirty: false,
                    $error: false,
                    $invalid: true,
                    $pending: false,
                    $params: []
                })
            },

            label: {
                type: String,
                default: ''
            },

            labelFor: {
                type: String,
                default: null
            },

            forceRequiredLabel: {
                type: Boolean,
                default: false
            },

            hideErrorMessage: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                labelForAttributeValue: ''
            };
        },

        mounted() {
            this.$nextTick(() => {
                this.setLabelForAttributeValue();
            });
        },

        updated() {
            this.$nextTick(() => {
                this.setLabelForAttributeValue();
            });
        },

        computed: {
            showLabelAsRequired() {
                if (this.forceRequiredLabel)
                    return true;

                return this.validator.required != null;
            }
        },

        watch: {
            labelFor() {
                this.setLabelForAttributeValue();
            }
        },

        methods: {
            setLabelForAttributeValue() {
                if (this.labelFor) {
                    this.labelForAttributeValue = this.labelFor;
                    return;
                }

                //let childFormComponents = this.$children.filter(child => {
                //    return (child.$el.localName === "input" || child.$el.localName === "select") && child.$el.id;
                //});

                //if (childFormComponents.length > 0) {
                //    this.labelForAttributeValue = childFormComponents[0].$el.id;
                //    return;
                //}

                return "";
            }
        }
    };
</script>